export default "__VITE_ASSET__D2AtyRUE__"